// Auto-generated file: Do not modify directly. Changes may be overwritten. Version: 1.3.0.

/*
 * Following tokens have been deprecated in version 1.3.0, please update your theme:
 *
 * Interactive/Focus has been split into two separate tokens. Please define 'Interactive/Focus Inner' and 'Interactive/Focus Outer' instead.
 * 'Interactive/Background Default' is deprecated. Please use 'Input/Background Default' instead.
 * 'Interactive/Background Disabled' is deprecated. Please use 'Input/Background Disabled' instead.
 * 'Interactive/Background Hovered' is deprecated. Please use 'Input/Background Hovered' instead.
 * 'Interactive/Background Pressed' is deprecated. Please use 'Input/Background Pressed' instead.
 * 'Interactive/Border Default' is deprecated. Please use 'Input/Border Default' instead.
 * 'Interactive/Border Hovered' is deprecated. Please use 'Input/Border Hovered' instead.
 * 'Interactive/Border Disabled' is deprecated. Please use 'Input/Border Disabled' instead.
 * 'Interactive/Border Critical Default' is deprecated. Please use 'Input/Border Critical' instead.
 * 'Pill' is deprecated. Please use 'Circle' instead.
 */

import type { GDSTheme } from "@leagueplatform/genesis-core";

export const EAPTheme: GDSTheme = {
  colors: {
    surface: {
      background: {
        primary: "#212121FF",
        secondary: "#353535FF",
        tertiary: "#353535FF",
      },
      card: {
        primary: "#212121FF",
        secondary: "#353535FF",
        disabled: "#353535FF",
      },
      screenHeader: { background: "#353535FF" },
      skeleton: {
        shimmer: {
          background: "#353535FF",
          overlay:
            "linear-gradient(90.0deg, #353535FF 0%, #35353580 50%, #353535E5 70%, #35353500 100%)",
        },
      },
    },
    onSurface: {
      text: {
        primary: "#FBF5EFFF",
        subdued: "#C4C0BBFF",
        reversed: "#212121FF",
        critical: "#EA5959FF",
        success: "#09C36AFF",
        warning: "#F2AB45FF",
      },
      border: { subdued: "#3D3C3AFF", default: "#5E5C5AFF", card: "#353535FF" },
      icon: { primary: "#FBF5EFFF" },
    },
    interactive: {
      action: {
        primary: "#FBF5EFFF",
        hovered: "#E5E0DBFF",
        pressed: "#D9D4CFFF",
        subdued: "#C2BDB8FF",
        disabled: "#77777AFF",
      },
      icon: { default: "#212121FF", disabled: "#77777AFF" },
      background: {
        default: "#212121FF",
        disabled: "#3E3C3BFF",
        hovered: "#353535FF",
        pressed: "#353535FF",
      },
      border: {
        default: "#5E5C5AFF",
        hovered: "#F57427FF",
        disabled: "#555049FF",
        critical: { default: "#EA5959FF" },
      },
      focus: { inner: "#FBF5EFFF", outer: "#FBF5EFFF" },
    },
    critical: {
      background: { subdued: "#EA5959FF", secondary: "#353535FF" },
      border: { default: "#EA5959FF" },
      icon: "#FBF5EFFF",
    },
    warning: {
      background: { subdued: "#404040FF", secondary: "#353535FF" },
      border: { default: "#F2AB45FF" },
      icon: "#FBF5EFFF",
    },
    success: {
      background: { subdued: "#515151FF", secondary: "#353535FF" },
      border: { default: "#FBF5EFFF" },
      icon: "#FFFBF5EF",
    },
    highlight: {
      background: { subdued: "#404040FF", secondary: "#353535FF" },
      border: { default: "#F57427FF" },
      icon: "#F57427FF",
    },
    decorative: {
      brand: {
        primary: {
          darkest: "#8C3400FF",
          dark: "#5E5C5AFF",
          default: "#F55B00FF",
          bright: "#FBF5EFFF",
          brightest: "#D88351FF",
          pastel: "#5B5B5BFF",
        },
        secondary: {
          darkest: "#172691FF",
          dark: "#1F33C4FF",
          default: "#243BE1FF",
          bright: "#576AEFFF",
          brightest: "#404040FF",
          pastel: "#5B5B5BFF",
        },
        tertiary: {
          darkest: "#172691FF",
          dark: "#1F33C4FF",
          default: "#243BE1FF",
          bright: "#576AEFFF",
          brightest: "#8693F4FF",
          pastel: "#C2C9F9FF",
        },
      },
    },
    primary: {
      background: {
        default: "#FBF5EFFF",
        hovered: "#E5E0DBFF",
        pressed: "#D9D4CFFF",
        critical: {
          default: "#EA5959FF",
          hovered: "#D34D4DFF",
          pressed: "#B94545FF",
        },
      },
      text: { default: "#212121FF", critical: { default: "#FBF5EFFF" } },
    },
    secondary: {
      background: {
        default: "#21212100",
        hovered: "#333333FF",
        pressed: "#333333FF",
      },
      text: { default: "#FBF5EFFF", hovered: "#FBF5EFFF" },
      border: { default: "#FBF5EFFF" },
    },
    tertiary: {
      background: {
        default: "#21212100",
        hovered: "#333333FF",
        pressed: "#333333FF",
      },
      text: { default: "#FBF5EFFF", hovered: "#FBF5EFFF" },
      border: { default: "#21212100" },
    },
    input: {
      border: {
        success: "#FBF5EFFF",
        warning: "#F2AB45FF",
        default: "#5E5C5AFF",
        hovered: "#F57427FF",
        disabled: "#555049FF",
        critical: "#EA5959FF",
      },
      background: {
        default: "#212121FF",
        disabled: "#3E3C3BFF",
        hovered: "#353535FF",
        pressed: "#353535FF",
      },
    },
    dataViz: {
      interface: { track: { border: "#515151FF", background: "#515151FF" } },
      singleColor: { brand: "#FBF5EFFF", neutral: "#FBF5EFFF" },
      status: {
        critical: "#F08686FF",
        warning: "#F2AB45FF",
        success: "#FFFBF5FF",
      },
      categorical: {
        one: "#C2C9F9FF",
        two: "#FBCDB1FF",
        three: "#FFC5CCFF",
        four: "#0BF485FF",
        five: "#FA001BFF",
        six: "#F2AB45FF",
      },
    },
  },
  shadows: {
    card: { x: 0, y: 0, blur: 0, spread: 0, color: "#FFFFFF00" },
    dropdown: { x: 0, y: 4, blur: 11, spread: 0, color: "#000000AB" },
  },
  typography: {
    headingOne: {
      fontFamily: "N/A",
      fontWeight: 300,
      lineHeight: 40,
      fontSize: 32,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    headingTwo: {
      fontFamily: "N/A",
      fontWeight: 400,
      lineHeight: 32,
      fontSize: 24,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    headingThree: {
      fontFamily: "N/A",
      fontWeight: 400,
      lineHeight: 28,
      fontSize: 20,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    headingFour: {
      fontFamily: "N/A",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    subtitleOne: {
      fontFamily: "N/A",
      fontWeight: 500,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    subtitleTwo: {
      fontFamily: "N/A",
      fontWeight: 500,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    bodyOne: {
      fontFamily: "N/A",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    bodyOneSecondary: {
      fontFamily: "N/A",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    bodyTwo: {
      fontFamily: "N/A",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    bodyTwoSecondary: {
      fontFamily: "N/A",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    buttonOne: {
      fontFamily: "N/A",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    buttonTwo: {
      fontFamily: "N/A",
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    label: {
      fontFamily: "N/A",
      fontWeight: 500,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    overline: {
      fontFamily: "N/A",
      fontWeight: 600,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0.6000000238418579,
      paragraphSpacing: 0,
      textCase: "uppercase",
      textDecoration: "none",
    },
    caption: {
      fontFamily: "N/A",
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    tab: {
      fontFamily: "N/A",
      fontWeight: 400,
      lineHeight: 12,
      fontSize: 10,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
  },
  spacing: {
    none: 0,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80,
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 2, innerFocus: 2, card: 0 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 12,
    huge: 20,
    circle: 99999,
    pill: 99999,
    button: 99999,
    inputField: 6,
    card: 6,
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4000,
    tooltip: 5000,
    modal: 8000,
    toast: 9000,
  },
  rem: {
    fontSizes: {
      headingOne: 2,
      headingTwo: 1.5,
      headingThree: 1.25,
      headingFour: 1.125,
      subtitleOne: 1,
      subtitleTwo: 0.875,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1,
      buttonTwo: 0.875,
      label: 0.75,
      overline: 0.75,
      caption: 0.75,
      tab: 0.625,
    },
    lineHeights: {
      headingOne: 2.5,
      headingTwo: 2,
      headingThree: 1.75,
      headingFour: 1.5,
      subtitleOne: 1.5,
      subtitleTwo: 1.25,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.25,
      label: 1,
      overline: 1,
      caption: 1,
      tab: 0.75,
    },
    baseSize: 16,
  },
  fonts: { headings: "N/A", body: "N/A" },
  transitions: { defaultTime: "200ms" },
};
